export default {
  DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_REQUEST: 'DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_REQUEST',
  DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_SUCCESS: 'DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_SUCCESS',
  DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_FAILURE: 'DOWNLOAD_MANAGE_INVENTORY_REPORT_BY_TYPE_FAILURE',

  DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_REQUEST: 'DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_REQUEST',
  DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_SUCCESS: 'DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_SUCCESS',
  DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_FAILURE: 'DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_FAILURE',

  FETCH_GAMES_LIST_REQUEST: 'FETCH_GAMES_LIST_REQUEST',
  FETCH_GAMES_LIST_SUCCESS: 'FETCH_GAMES_LIST_SUCCESS',
  FETCH_GAMES_LIST_FAILURE: 'FETCH_GAMES_LIST_FAILURE',

  FETCH_PACKS_LIST_REQUEST: 'FETCH_PACKS_LIST_REQUEST',
  FETCH_PACKS_LIST_SUCCESS: 'FETCH_PACKS_LIST_SUCCESS',
  FETCH_PACKS_LIST_FAILURE: 'FETCH_PACKS_LIST_FAILURE',

  FETCH_PACKS_GROSS_VALUE_LIST_REQUEST: 'FETCH_PACKS_GROSS_VALUE_LIST_REQUEST',
  FETCH_PACKS_GROSS_VALUE_LIST_SUCCESS: 'FETCH_PACKS_GROSS_VALUE_LIST_SUCCESS',
  FETCH_PACKS_GROSS_VALUE_LIST_FAILURE: 'FETCH_PACKS_GROSS_VALUE_LIST_FAILURE',

  FETCH_PACK_DETAILS_REQUEST: 'FETCH_PACK_DETAILS_REQUEST',
  FETCH_PACK_DETAILS_SUCCESS: 'FETCH_PACK_DETAILS_SUCCESS',
  FETCH_PACK_DETAILS_FAILURE: 'FETCH_PACK_DETAILS_FAILURE',

  FETCH_ORDER_DETAILS_REQUEST: 'FETCH_ORDER_DETAILS_REQUEST',
  FETCH_ORDER_DETAILS_SUCCESS: 'FETCH_ORDER_DETAILS_SUCCESS',
  FETCH_ORDER_DETAILS_FAILURE: 'FETCH_ORDER_DETAILS_FAILURE',

  FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_REQUEST: 'FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_REQUEST',
  FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_SUCCESS: 'FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_SUCCESS',
  FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_FAILURE: 'FETCH_INSTANT_GAMES_TRANSITIONS_HISTORY_FAILURE',

  FETCH_LIABILITIES_REQUEST: 'FETCH_LIABILITIES_REQUEST',
  FETCH_LIABILITIES_SUCCESS: 'FETCH_LIABILITIES_SUCCESS',
  FETCH_LIABILITIES_FAILURE: 'FETCH_LIABILITIES_FAILURE',

  FETCH_ORDER_HISTORY_REQUEST: 'FETCH_ORDER_HISTORY_REQUEST',
  FETCH_ORDER_HISTORY_SUCCESS: 'FETCH_ORDER_HISTORY_SUCCESS',
  FETCH_ORDER_HISTORY_FAILURE: 'FETCH_ORDER_HISTORY_FAILURE',

  ON_ITEM_LIST_SELECTION: 'ON_ITEM_LIST_SELECTION',
  RESET_DETAILS_DIALOG_DATA: 'RESET_DETAILS_DIALOG_DATA',
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/action-types.js